import { faLog } from "./common/faCommon.js";
import { createI18n } from "vue-i18n";
// import { getLocale } from "./common/appStore.js";

/**
 * Load locale messages
 *
 * The loaded `JSON` locale messages is pre-compiled by `@intlify/vue-i18n-loader`, which is integrated into `vue-cli-plugin-i18n`.
 * See: https://github.com/intlify/vue-i18n-loader#rocket-i18n-resource-pre-compilation
 */
export function loadLocaleMessages() {
    faLog(0, "[i18n] [loadLocaleMessages]");
    const locales = require.context("./locales", true, /[A-Za-z0-9-_,\s]+\.json$/i);
    const messages = {};
    locales.keys().forEach((key) => {
        const matched = key.match(/([A-Za-z0-9-_]+)\./i);
        if (matched && matched.length > 1) {
            const locale = matched[1];
            messages[locale] = locales(key);
        }
    });
    // faLog(2, "[i18n] [loadLocaleMessages] locales", locales);
    // faLog(2, "[i18n] [loadLocaleMessages] messages", messages);
    return messages;
}

const i18n = createI18n({
    allowComposition: true,
    locale: "ko",
    fallbackLocale: "en",
    messages: loadLocaleMessages(),
    legacy: false,
});

export default i18n;
